import { TextField } from ".";

const NumberField = ({ withDecimals, min, max, ...props }) => {
  const pattern = withDecimals 
    ? { value: /^\d+(\.\d{1,2})?$/ }
    : { value: /^\d+$/ };
  
  const validate = (value) => {
    const numValue = parseFloat(value);
    
    if (isNaN(numValue)) {
      return "Debe ser un número válido";
    }
    
    if (min !== undefined && numValue < min) {
      return `El valor debe ser mayor o igual a ${min}`;
    }
    
    if (max !== undefined && numValue > max) {
      return `El valor debe ser menor o igual a ${max}`;
    }
    
    return true;
  };

  const rules = {
    required: props.required,
    pattern,
    validate
  };
  
  const helperText = withDecimals
    ? "Solo números (con hasta 2 decimales)"
    : "Solo números (sin espacios, guiones o caracteres especiales)";

  return (
    <TextField
      rules={rules}
      helperText={props.helperText || helperText}
      {...props}
    />
  );
};

export default NumberField;